/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { InputText } from "../../../components/InputText";
import { Button } from "../../../components/Button";
import { Label } from "../../../components/Label";
import { InputSelectDefault } from "../../../components/InputSelectDefault";
import BrandRepository from "../../../repositories/BrandRepository";
import { toastr } from "react-redux-toastr";

const VehicleData = ({
  values,
  errors,
  handleChange,
  trigger,
  nextPage,
  previousPage,
  selectHeight,
}) => {
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const { brand, model, licensePlate } = values;

  useEffect(() => {
    const loadBrands = async () => {
      try {
        const brandsData = await BrandRepository.getBrands();
        const mappedBrands = brandsData.map((b) => ({
          value: b.id,
          label: b.Brand,
        }));
        setBrandOptions(mappedBrands);
      } catch (error) {
        console.error("Error loading brands:", error);
      }
    };
    loadBrands();
  }, []);

  useEffect(() => {
    const loadModels = async () => {
      if (brand?.label) {
        try {
          const modelsData = await BrandRepository.getModelsByDescription(
            brand.label
          );
          const mappedModels = modelsData.map((m) => ({
            value: m.id,
            label: m.Model,
          }));
          setModelOptions(mappedModels);
        } catch (error) {
          console.error("Error loading models:", error);
        }
      } else {
        setModelOptions([]);
      }
    };

    loadModels();
  }, [brand]);

  const handleNextPage = async () => {
    const isValid = await trigger(["brand", "model"]);
    if (isValid) {
      nextPage();
    } else {
      toastr.error("Erro", "Por favor, preencha todos os campos obrigatórios.");
    }
  };

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <h4 style={{ margin: 0 }}>
          <b>Dados do Veículo</b>
        </h4>
        <p style={{ fontSize: "small" }}>
          Informe os dados do seu veículo para acompanhar o histórico.
        </p>
      </div>
      <div style={{ width: "100%" }}>
        <Label>Placa</Label>
        <InputText value={licensePlate} isDisabled />

        <Label required>Marca</Label>
        <div className="signup-select">
          <InputSelectDefault
            name="brand"
            height={selectHeight}
            options={brandOptions}
            width="100%"
            value={brand}
            isSearchable
            isClearable
            onChange={(value) => {
              handleChange("brand", value);
              handleChange("model", null);
            }}
            onBlur={() => trigger(["brand"])}
            error={errors.brand}
          />
        </div>

        <Label required>Modelo</Label>

        <div className="signup-select">
          <InputSelectDefault
            name="model"
            height={selectHeight}
            options={modelOptions}
            width="100%"
            isSearchable
            isClearable
            value={model}
            onChange={(value) => handleChange("model", value)}
            onBlur={() => trigger(["model"])}
            error={errors.model}
            disabled={!brand}
          />
        </div>
      </div>
      <br />
      <div className="signup-form-div-buttons" style={{ width: "100%" }}>
        <Button onClick={previousPage} color="red400" type="button">
          Voltar
        </Button>
        <Button onClick={handleNextPage} color="green450" type="button">
          Avançar
        </Button>
      </div>
    </>
  );
};

export default VehicleData;
